import { extend } from "flarum/common/extend";
import app from "flarum/forum/app";
import username from "flarum/common/helpers/username";
import Icon from "flarum/common/components/Icon";
import punctuateSeries from "flarum/common/helpers/punctuateSeries";
import Avatar from "flarum/common/components/Avatar";
import ItemList from "flarum/common/utils/ItemList";
import humanTime from "flarum/common/utils/humanTime";
import CommentPost from "flarum/forum/components/CommentPost";
import Link from "flarum/common/components/Link";
import DiscussionPage from "flarum/forum/components/DiscussionPage";
import FieldSet from "flarum/common/components/FieldSet";
import PostDiscussionViewsModal from "./PostDiscussionViewsModal";
export default function () {
  extend(DiscussionPage.prototype, "sidebarItems", function (items) {
    if (app.forum.attribute("showViewList") == 0 || !this.discussion.canViewList()) return;
    const views = this.discussion.latestViews();
    const viewList = new ItemList();
    views.forEach((view, key) => {
      const userName = view.user() === false ? app.translator.trans("michaelbelgium-discussion-views.forum.viewlist.guest") : username(view.user());
      let listitem = m("div", {
        className: "item-lastUser-content"
      }, m(Avatar, {
        user: view.user()
      }), m("div", null, userName, m("span", {
        className: "lastUser-visited",
        title: view.visitedAt().toLocaleString()
      }, humanTime(view.visitedAt()))));
      if (view.user() !== false) {
        listitem = Link.component({
          href: app.route.user(view.user())
        }, listitem);
      }
      viewList.add("lastUser-" + key, listitem);
    });
    items.add("lastDiscussionViewers", FieldSet.component({
      className: "LastDiscussionUsers",
      label: app.translator.trans("michaelbelgium-discussion-views.forum.viewlist.title")
    }, viewList.toArray()));
  });
  extend(CommentPost.prototype, "footerItems", function (items) {
    if (app.forum.attribute("showFooterViewList") == 0) return;
    const post = this.attrs.post;
    const discussion = post.discussion();
    if (!discussion.canViewList()) return;
    const firstPost = discussion.firstPost();
    if (!firstPost) return; //if first post isn't loaded

    const parsedLimit = parseInt(app.forum.attribute('maxListCount'));
    const limit = isNaN(parsedLimit) ? 5 : parsedLimit;
    const views = discussion.uniqueViews();
    if (firstPost.id() == post.id() && views.length > 0) {
      const names = views.slice(0, limit).map(view => Link.component({
        href: app.route.user(view.user())
      }, view.user() === app.session.user ? app.translator.trans("michaelbelgium-discussion-views.forum.post.you") : username(view.user())));
      if (views.length > limit) {
        names.push(Link.component({
          href: "#",
          onclick: e => {
            e.preventDefault();
            app.modal.show(PostDiscussionViewsModal, {
              post
            });
          }
        }, app.translator.trans("michaelbelgium-discussion-views.forum.post.others_link", {
          count: views.length - limit
        })));
      }
      if (names.length > 0) {
        items.add("viewed", m("div", {
          className: "Post-Discussion-viewedBy"
        }, m(Icon, {
          name: "fas fa-eye"
        }), app.translator.trans("michaelbelgium-discussion-views.forum.post.viewed_by", {
          users: punctuateSeries(names)
        })));
      }
    }
  });
}